import { render, staticRenderFns } from "./AssignMember.vue?vue&type=template&id=42bf881e"
import script from "./AssignMember.vue?vue&type=script&lang=js"
export * from "./AssignMember.vue?vue&type=script&lang=js"
import style0 from "./AssignMember.vue?vue&type=style&index=0&id=42bf881e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports